import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { Spinner } from "react-bootstrap";

import { Button, Modal, Typography } from "@virkesborsen/ui-component-library";
import { apiFetch } from "../../../../../api/client";

import KlarnaCheckout from "../components/KlarnaCheckout";

const PaymentSelectionStep = ({ checkoutData, skipKlarnaCheckout }) => {
  const { property } = checkoutData;

  const [checkoutMarkup, setCheckoutMarkup] = useState(undefined);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchCheckoutData();
  }, []);

  const reloadCheckout = () => {
    fetchCheckoutData();
  };

  const fetchCheckoutData = async () => {
    setIsLoading(true);
    setError(null);

    const requestBody = {
      ref: property.ref,
    };

    if (checkoutData?.couponCode) {
      requestBody.coupon_code = checkoutData?.couponCode;
    }

    try {
      const response = await apiFetch("/dfr-api/checkout/", {
        method: "POST",
        body: JSON.stringify(requestBody),
      });

      setIsLoading(false);

      if (!response.ok) {
        console.error("Checkout error:", response.error);
        setError(response.message || "An error occurred");
        return;
      }

      const { klarna_html } = response.data;

      if (klarna_html) {
        setCheckoutMarkup(klarna_html);
      } else {
        skipKlarnaCheckout();
      }
    } catch (err) {
      setIsLoading(false);
      setError("Network error occurred");
      console.error("Network error:", err);
    }
  };

  if (isLoading) {
    return (
      <Modal.Content>
        <CenteredContainer>
          <div className="d-flex justify-content-center align-items-center w-100 h-100">
            <Spinner animation="border" variant="primary" />
          </div>
        </CenteredContainer>
      </Modal.Content>
    );
  }

  if (error) {
    return (
      <Modal.Content>
        <CenteredContainer>
          <Typography variant="bodyMedium" color="error">
            {error}
          </Typography>
          <Button
            variant="secondary"
            onClick={reloadCheckout}
            label="Försök igen"
          />
        </CenteredContainer>
      </Modal.Content>
    );
  }

  return (
    <Modal.Content>
      {checkoutMarkup ? (
        <KlarnaCheckout htmlMarkup={checkoutMarkup} />
      ) : (
        <CenteredContainer>
          <Typography variant="bodyMediumBaseRegular">
            Oj, något gick fel när vi försökte ladda in Klarna Checkout.
          </Typography>
          <Button
            variant="secondary"
            onClick={reloadCheckout}
            label="Försök igen"
          />
        </CenteredContainer>
      )}
    </Modal.Content>
  );
};

const CenteredContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
  flex-direction: column;
  gap: 8px;
`;

PaymentSelectionStep.displayName = "PaymentSelection";

export default PaymentSelectionStep;
